
// # session 配置
// SESSION_ENGINE = 'django.contrib.sessions.backends.db'  # 引擎（默认）
// SESSION_COOKIE_DOMAIN = None  # Session的cookie保存的域名（默认）
// SESSION_COOKIE_SECURE = False  # 是否Https传输cookie（默认）
// SESSION_COOKIE_HTTPONLY = True  # 是否Session的cookie只支持http传输（默认）
// SESSION_COOKIE_AGE = 60  # Session的cookie失效日期（1209600 2周 默认）
// SESSION_EXPIRE_AT_BROWSER_CLOSE = True  # 是否关闭浏览器使得Session过期（False 默认）
// SESSION_SAVE_EVERY_REQUEST = False  # 是否每次请求都保存Session，默认修改之后才保存

// # 跨域忽略
// CORS_ALLOW_CREDENTIALS = True  # 允许带cookie
// CORS_ORIGIN_ALLOW_ALL = True   # 允许所有源访问

export default{
    SESSION_EXPIRE_AT_BROWSER_CLOSE:true
}